import(/* webpackMode: "eager" */ "/workspace/dotheforgejo/oxpa-pro/src/app/map/page.tsx");
